import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonToggle,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';

@Component({
  selector: 'app-two-choices-control',
  templateUrl: './two-choices-control.component.html',
  styleUrls: ['./two-choices-control.component.scss'],
  imports: [
    IonLabel,
    IonList,
    IonItem,
    IonButton,
    IonModal,
    IonContent,
    IonFooter,
    TranslatePipe,
    GlobalPageHeaderComponent,
    IonToggle,
  ],
})
export class TwoChoicesControlComponent {
  @Input() title?: string;
  @Input() firstLabel?: string;
  @Input() firstValue?: number;
  @Input() secondLabel?: string;
  @Input() secondValue?: number;
  @Input() value?: number = 0;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onChange = new EventEmitter<any>();

  constructor() {}

  onChangePress(value: number) {
    this.onChange.emit(value);
  }
}
